// extracted by mini-css-extract-plugin
module.exports = {"itemWrapper":"EmarsysRecommendations_itemWrapper__23a21","missingConsent":"EmarsysRecommendations_missingConsent__9bc28","titleCenter":"EmarsysRecommendations_titleCenter__f8bab"};